import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

import { carousel } from "./carousel";
import { header } from "./header";
import { blockLink } from "./block-link";
import { overlay } from "./overlay";
import { videoCover } from "./video-cover";

/* plugins */
Alpine.plugin(collapse);

/* components */
Alpine.data('carousel', carousel);
Alpine.data('header', header);
Alpine.data('blockLink', blockLink);
Alpine.data('overlay', overlay);
Alpine.data('videoCover', videoCover);

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
